<template>
  <v-content class="bg-content">
    <v-container grid-list-xl class="card-animate-2">
      <sequential-entrance fromBottom>
       <v-layout row wrap class="container-fonts" style="padding: 20px;">
          <v-flex sm6 xs6 md4 lg12>
            <VoiceSearchBar style="margin-left: 750px;"/>
          </v-flex>
            <v-flex sm6 xs6 md6 lg2> 
              <v-card href="/dashboard" target="_self" class="theme-bg-card-2">
                <v-flex>
      
                  <img
                    class="center"
                    style="height: 30%; width: 30%"
                    src="@/assets/InterfaceIcon.png"
                  />
                  <v-card-title class="justify-center">
                    Dashboard
                  </v-card-title>
      
                </v-flex>
              </v-card>
            </v-flex>

            <v-flex sm6 xs6 md6 lg2>
              <v-card href="/interface" target="_self" class="theme-bg-card-2">
                <v-flex>
      
                  <img
                    class="center"
                    style="height: 30%; width: 30%"
                    src="@/assets/InterfaceIcon2.png"
                  />
                  <v-card-title class="justify-center">
                    Interface
                  </v-card-title>
      
                </v-flex>
              </v-card>
            </v-flex>

            <v-flex sm6 xs6 md2 lg2>
              <v-card href="/dailybriefing" target="_self" class="theme-bg-card-2">
                <v-flex>
      
                  <img
                    class="center"
                    style="height: 30%; width: 30%"
                    src="@/assets/briefing.png"
                  />
                  <v-card-title class="justify-center">
                    Briefing
                  </v-card-title>
      
                </v-flex>
              </v-card>
            </v-flex>
            <v-flex sm6 xs6 md2 lg2>
              <v-card href="/tasks" target="_self" class="theme-bg-card-2">
                <v-flex>
      
                  <img
                    class="center"
                    style="height: 30%; width: 30%"
                    src="@/assets/TaskIcon.png"
                  />
                  <v-card-title class="justify-center"> Tasks </v-card-title>
      
                </v-flex>
              </v-card>
            </v-flex>
            <v-flex sm6 xs6 md2 lg2>
              <v-card href="/calendar" target="_self" class="theme-bg-card-2">
                <v-flex>
      
                  <img
                    class="center"
                    style="height: 30%; width: 30%"
                    src="@/assets/CalendarIcon.png"
                  />
                  <v-card-title class="justify-center"> Calendar </v-card-title>
      
                </v-flex>
              </v-card>
            </v-flex>
            <v-flex sm6 xs6 md2 lg2>
              <v-card href="/chat" target="_self" class="theme-bg-card-2">
                <v-flex>
      
                  <img
                    class="center"
                    style="height: 30%; width: 30%"
                    src="@/assets/ChatIcon.png"
                  />
                  <v-card-title class="justify-center"> AI Mouse </v-card-title>
      
                </v-flex>
              </v-card>
            </v-flex>
            <br />
            <Animation10 class="animation" style="width: 100%; margin-top: 30px;" />
            <!-- <Animation11 class="animation1" style="width: 100%; margin-top: 30px;" />
            <Animation12 class="animation2" style="width: 100%; margin-top: 30px;" /> -->
            <Animation13 class="animation3" style="width: 100%; margin-top: 30px;" />
            <Animation16 class="animation4" style="width: 100%; margin-top: 30px;" />
            <ScriptRunnerButton/>
        </v-layout>
        </sequential-entrance>
  </v-container>


      <v-overlay :absolute="absolute" :value="overlay" opacity="0.85">
        <!-- <v-btn text small color="success" @click="showCard = false">X</v-btn> -->
        <v-btn
          class="mx-2 close-btn"
          fab
          dark
          small
          color="#ccc"
          @click="overlay = false"
          >X</v-btn
        >
        <v-layout row wrap v-if="!this.productDetails">
          <v-flex>
            <Bar
              v-if="this.activeDetails.Report"
              class="product-animate detail-card"
            />
            <Task
              v-if="this.activeDetails.Task"
              class="product-animate detail-card"
            />
          </v-flex>
        </v-layout>
      </v-overlay>
    
  </v-content>
</template>

<script>
import ScriptRunnerButton from '@/components/ScriptRunnerButton.vue'
import Task from '@/components/Task.vue';
import Animation10 from '@/components/Animation10.vue';
import Animation13 from '@/components/Animation13.vue';
import Animation16 from '@/components/Animation16.vue';
import VoiceSearchBar from './../components/VoiceSearchBar.vue';
export default {
  name: 'Dashboard',
  components: {
    ScriptRunnerButton,
    Animation10,
    Animation13,
    Animation16,
    Task,
    VoiceSearchBar
  },
  data() {
    return {
      productDetails: true,
      activeDetails: {
        Toolbar: false,
        Task: false,
      },
      absolute: true,
      overlay: false,
      title: '',

      date: new Date().toDateString(),
      position: '',
      icons: [
        { text: 'Calendar', icon: 'mdi mdi-calendar-today' },
        { text: 'Email', icon: 'mdi mdi-email' },
        { text: 'Report', icon: 'mdi mdi-chart-bar' },
        { text: 'Task', icon: 'mdi mdi-check-outline' },
        { text: 'Weather', icon: 'mdi mdi-weather-cloudy' },
        { text: 'Bank', icon: 'mdi mdi-bank' },
      ],
      item: 1,
      selectedItem: 1,
      menu: false,
      userInfo: {},
      items: [
        { text: 'Home', icon: 'mdi-home', nav: 'home' },
        -{ text: 'Dashboard', icon: 'mdi-view-dashboard', nav: 'dashboard' },
        { text: 'Agenda', icon: 'mdi-view-agenda', nav: 'dailyagenda' },
        { text: 'Training', icon: 'mdi-cube-outline', nav: 'training' },
        { text: 'Sales', icon: 'mdi-account', nav: 'salesdepartment' },
        {
          text: 'Appointments',
          icon: 'mdi-calendar-text',
          nav: 'appointments',
        },
        { text: 'Forms', icon: 'mdi-account-edit', nav: 'forms' },
        {
          text: 'Sentimental Analysis',
          icon: 'mdi-clock',
          nav: 'sentimental-analysis',
        },
        { text: 'Help', icon: 'mdi-help', nav: 'help' },
        { text: 'Logout', icon: 'mdi-flag', nav: 'login' },
      ],
    };
  },
  methods: {
    readOutLoud: (msg) => {
      const speech = new SpeechSynthesisUtterance();
      const voiceName = 'Google UK English Male';
      speech.volume = 1;
      speech.rate = 1;
      speech.pitch = 1;
      speech.voice = speechSynthesis.getVoices().filter(function (voice) {
      return voice.name === voiceName
    })[0]
      speech.text = msg;
      window.speechSynthesis.speak(speech);

     speech.onend = function() {
      setTimeout(() => {
      Event.$emit('speakModeOn');
      }, 4000);
     };
    },
    handleAuthClick(event) {
      console.log(event);
      window.gapi.auth2.getAuthInstance().signIn();
    },
    handleSignoutClick(event) {
      console.log(event);
      window.gapi.auth2.getAuthInstance().signOut();
    },
    updateSigninStatus(isSignedIn) {
      if (isSignedIn) {
        //With Google
        console.log('Logged In');
        this.listMessages();
        this.unreadMail();
      } else {
        console.log('Logged out');
      }
    },
    initClient() {
      window.gapi.client
        .init({
          apiKey: 'AIzaSyCwSEFovFNJ9L_47CuTBIGGJ4qntTOJmrM',
          clientId:
            '292320827989-nou250q4tjpk0j0h4j5poodgai5km88f.apps.googleusercontent.com',
          discoveryDocs: [
            'https://www.googleapis.com/discovery/v1/apis/gmail/v1/rest',
            'https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest',
          ],
          scope: [
            'https://mail.google.com/',
            'https://www.googleapis.com/auth/calendar.readonly',
          ],
        })
        .then(
          () => {
            window.gapi.auth2
              .getAuthInstance()
              .isSignedIn.listen(this.updateSigninStatus);
            this.updateSigninStatus(
              window.gapi.auth2.getAuthInstance().isSignedIn.get()
            );
          },
          (error) => {
            console.log(error);
          }
        );
    },
    listMessages() {
      window.gapi.client.gmail.users.messages
        .list({
          userId: 'me',
        })
        .then(function (response) {
          console.log(response.result);
        });
    },
    unreadMail() {
      window.gapi.client.gmail.users.labels
        .list({
          userId: 'me',
        })
        .then(function (response) {
          console.log(response.result);
        });
    },
    nav(path) {
      this.$router.push({ name: path });
    },
    showCard(item) {
      this.selectedItem = 4;
      this.overlay = true;
      this.productDetails = false;
      for (var key in this.activeDetails) {
        // skip loop if the property is from prototype

        if (key === item) {
          this.title = item;
          this.activeDetails[key] = true;
          console.log(key + ' is true');
        } else {
          this.activeDetails[key] = false;
          console.log(key + ' is false');
        }
      }
    },
    getEvents() {
      window.gapi.client.calendar.events
        .list({
          calendarId: 'primary',
          timeMin: new Date(2019, 1, 1).toISOString(),
          timeMax: new Date().toISOString(),
          showDeleted: false,
          singleEvents: true,
          maxResults: 10,
          orderBy: 'startTime',
        })
        .then((response) => {
          this.items = response.result.items;
          console.log(this.items);
        });
    },

    countDown(time, update, complete) {
      var start = new Date().getTime();
      let self = this;
      self.interval = setInterval(function () {
        var now = time - (new Date().getTime() - start);
        if (now <= 0) {
          clearInterval(self.interval);
          complete();
        } else update(Math.floor(now / 1000));
      }, 100); // the smaller this number, the more accurate the timer will be
    },
    convertTime(sec, delayed) {
      let hours = Math.floor(sec / 3600);
      hours >= 1 ? (sec = sec - hours * 3600) : (hours = '00');
      let min = Math.floor(sec / 60);
      min >= 1 ? (sec = sec - min * 60) : (min = '00');
      sec < 1 ? (sec = '00') : void 0;
      min.toString().length == 1 ? (min = '0' + min) : void 0;
      sec.toString().length == 1 ? (sec = '0' + sec) : void 0;
      if (document.getElementById('timer')) {
        document.getElementById('timer').innerHTML =
          `<span style="color:${delayed == 'delayed' ? 'red;' : '#44da91;'}">` +
          hours +
          ':' +
          min +
          ':' +
          sec +
          ' <strong >' +
          delayed +
          ' <strong> </span>';
      }
    },
  },
  beforeDestroy: function () {
    clearInterval(this.interval);
  },
  mounted() {
    if (!localStorage.currentUser) {
      this.readOutLoud(`Please Confirm you authentication first`);
      this.$router.push({ name: 'login' });
    }
    this.userInfo = JSON.parse(localStorage.getItem('currentUser'));

    let self = this;
    this.countDown(
      900000, // milliseconds
      (timeleft) => {
        self.convertTime(timeleft, 'remaining'); // If time is remaining
      },
      () => {
        self.readOutLoud(
          `You have four pending decision's to make, should we get them done?`
        );
        let i = 0;
        setInterval(() => {
          i = ++i;
          self.convertTime(i, 'delayed'); // Time is delayed
        }, 1000);
      },
      2000
    );

    var myDate = new Date();
    var hrs = myDate.getHours();
    var greet;
    if (hrs < 12)
      greet = 'Rendering Cell Funds Business Intelligence Dashboard';
    else if (hrs >= 12 && hrs <= 17)
      greet = 'Rendering Cell Funds Business Intelligence Dashboard';
    else if (hrs >= 17 && hrs <= 24)
      greet = 'Rendering Cell Funds Business Intelligence Dashboard';
    greet = '';
    this.readOutLoud(`${greet}`);

    window.gapi.load('client:auth2', this.initClient);

    Event.$on('command', (data) => {
      if (!data) return;
      this.overlay = true;
      this.productDetails = false;

      if (
        data.msg.indexOf('emails') !== -1 ||
        data.msg.indexOf('email') !== -1 ||
        data.msg.indexOf('mails') !== -1
      ) {
        this.showCard('Email');

        return;
      } else if (
        data.msg.indexOf('task') !== -1 ||
        data.msg.indexOf('tasks') !== -1
      ) {
        this.showCard('Task');
        return;
      } else if (
        data.msg.indexOf('events') !== -1 ||
        data.msg.indexOf('event') !== -1
      ) {
        this.showCard('Events');
        return;
      } else if (
        data.msg.indexOf('setting') !== -1 ||
        data.msg.indexOf('settings') !== -1
      ) {
        this.showCard('Settings');
        return;
      } else if (data.msg.indexOf('report') !== -1) {
        this.showCard('Report');
        return;
      } else if (data.msg.indexOf('reports') !== -1) {
        this.showCard('Report');
        return;
      } else if (
        data.msg.indexOf('appointment') !== -1 ||
        data.msg.indexOf('appointments') !== -1
      ) {
        this.showCard('AppointmentCalendar');
        return;
      } else if (
        data.msg.indexOf('agenda') !== -1 ||
        data.msg.indexOf("today's agenda") !== -1
      ) {
        this.showCard('Agenda');
        return;
      } else if (data.msg.indexOf('calendar') !== -1) {
        this.showCard('Calendar');
        return;
      } else if (
        data.msg.indexOf('google maps') !== -1 ||
        data.msg.indexOf('directions') !== -1
      ) {
        this.showCard('Map');
        return;
      } else if (
        data.msg.indexOf('videocall') !== -1 ||
        data.msg.indexOf('videocalls') !== -1
      ) {
        this.showCard('VideoCalls');
        return;
      } else if (
        data.msg.indexOf('mix 1') !== -1 ||
        data.msg.indexOf('play mix 1') !== -1
      ) {
        this.showCard('VideoPlayer');
        return;
      } else if (
        data.msg.indexOf('mix 2') !== -1 ||
        data.msg.indexOf('play mix 2') !== -1
      ) {
        this.showCard('VideoPlayer2');
        return;
      } else if (
        data.msg.indexOf('mix 3') !== -1 ||
        data.msg.indexOf('play mix 3') !== -1
      ) {
        this.showCard('VideoPlayer3');
        return;
      } else if (
        data.msg.indexOf('mix 4') !== -1 ||
        data.msg.indexOf('play mix 4') !== -1
      ) {
        this.showCard('VideoPlayer4');
        return;
      } else if (
        data.msg.indexOf('chatroom') !== -1 ||
        data.msg.indexOf('chat') !== -1
      ) {
        this.showCard('Chat');
        return;
      }
    });
    Event.$on('showProductDetails', () => {
      console.log('Show Product');
      this.overlay = true;
      this.productDetails = true;
    });
    Event.$on('weatherReport', (data) => {
      if (
        (data.msg && data.msg.indexOf('weather') !== -1) ||
        (data.msg && data.msg.indexOf('climate') !== -1)
      ) {
        this.showCard('Weather');
        return;
      }
    });
  },
};
</script>

<style scoped>

.animation {
  position: relative;
  top: -35px;
  font-size: 15px;
  min-height: 0px;
  left: -32%;
  right: 0px;
  border-radius: 10px;
  color: #fff;
}

.animation1 {
  position: absolute;
  top: 440px;
  font-size: 15px;
  min-height: 0px;
  left: -32%;
  right: 0%;
  border-radius: 10px;
  color: #fff;
}

.animation2 {
  position: absolute;
  top: 440px;
  font-size: 15px;
  min-height: 0px;
  left: 32%;
  right: 0%;
  border-radius: 10px;
  color: #fff;
}

.animation3 {
  position: absolute;
  top: 175px;
  font-size: 15px;
  min-height: 0px;
  left: 35%;
  right: 0%;
  border-radius: 10px;
  color: #fff;
}

.animation4 {
  position: absolute;
  top: 200px;
  font-size: 15px;
  min-height: 0px;
  left: 22%;
  right: 0%;
  border-radius: 10px;
  color: #fff;
}

.div {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.chart-text {
  color: #fff;
  text-align: center;
  font-size: 1.3rem;
  font-weight: normal;
  font-family: 'Courier New', Courier, monospace;
}

.tile-title {
  color: #fff;
  text-align: center;
  font-size: 1.7rem;
  font-weight: normal;
  font-family: Arimo, sans-serif;
}
@media only screen and (max-width: 600px) {
    .tile-title {
     color: #fff;
     text-align: center;
     font-size: 1.3rem;
     font-weight: normal;
     font-family: Arimo, sans-serif;
   }
}
@media only screen and (max-width: 900px) {
    .tile-title {
     color: #fff;
     text-align: center;
     font-size: 1.7rem;
     font-weight: normal;
     font-family: Arimo, sans-serif;
   }
}
.chart-title {
  color: #fff;
  text-align: center;
  font-size: 1rem;
  font-weight: thin;
  font-family: Arimo, sans-serif;
}

.column {
  width: 100%;
}

@media (min-width: 600px) {
  .column {
    width: 50%;
  }
}

.chart-content {
  background: rgba(12, 22, 27, 0.4);
  outline-color: rgba(90, 128, 191, 0.5);
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #5a80bf;
  box-shadow: 0 0 5px rgba(120, 204, 226, 0.4), inset 0 0 10px rgba(120, 204, 226, 0.2), 0 4px 0 #000;
  color: #efe;
  outline-width: 2px;
  padding: 25px;
  border-radius: 10px;
  margin: 0px;
}

@-webkit-keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
  height: 150%;
}


@media only screen and (max-width: 600px) {
.chart-content {
  background: rgba(12, 22, 27, 0.4);
  outline-color: rgba(90, 128, 191, 0.5);
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #5a80bf;
  box-shadow: 0 0 5px rgba(120, 204, 226, 0.4), inset 0 0 10px rgba(120, 204, 226, 0.2), 0 4px 0 #000;
  color: #efe;
  outline-width: 2px;
  padding: 25px;
  border-radius: 10px;
  margin: 0px;
}

@-webkit-keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
  height: 150%;
}

}

.card {
  margin-left: 1rem;
  padding: 20px;
  width: 100%;
  height: 425px;
  cursor: pointer;
}
.row {
  display: flex;
  flex-direction: row;
  margin-top: 2rem;
}

.flexbox {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 1200px;
  height: 350px;
  overflow: hidden;
  margin: 0 auto;
  padding: 0px;
  transition: all 1s ease-in-out;
}

.flexbox:hover {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 1200px;
  height: 425px;
  overflow: hidden;
  margin: 0 auto;
  padding: 0px;
  transition: scale(1.1);
}

.flexbox .board {
  display: flex;
  flex-direction: column;
  min-width: 350px;
  max-width: 100%;
  background-color: transparent;
  padding: 0px;
}

.flexbox .board .card {
  padding: 5px;
  background: rgba(48, 64, 87, 0.3);
  outline-color: #42da91;
  color: #fff;
  min-width: 390px;
  max-width: 390px;
  cursor: pointer;
}

.ma-2 {
  width: 180px;
  transition: all 0.7s ease-in-out;
}

.ma-2:hover {
  width: 220px;
  transition: scale(1.1);
}

.html,
body {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  background-color: #222;
  font-size: 0;
}
.svg {
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  position: absolute;
}
.h1 {
  width: 100%;
  font-family: sans-serif;
  position: absolute;
  text-align: center;
  color: white;
  font-size: 18px;
  top: 40%;
  opacity: 1;
  transition: opacity 1s ease-in-out;
  -moz-transition: opacity 1s ease-in-out;
  -webkit-transition: opacity 1s ease-in-out;
}

.h1 a {
  color: #48b1f4;
  text-decoration: none;
}

.path {
  stroke-linecap: square;
  stroke: white;
  stroke-width: 0.5px;
}

.space {
  height: 20px;
}

.theme-icons {
  background: #304057;
  color: #fff;
  size: 100px;
}

.theme-icons:hover {
  background: #304057;
  color: #fff;
}

.theme-bg-player {
  width: 800px;
}

.theme-bg-card {
  text-decoration: none;
  font-family: Arial, Helvetica, sans-serif;
  background: rgba(48, 64, 87, 0.6);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.6);
  top: -70px;
}

.theme-bg-card:hover {
  text-decoration: none;
  background: rgba(48, 64, 87, 0.8);
  outline-color: #42da91;
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #42da91;
  box-shadow: 0 0 10px rgba(90, 128, 191, 0.2), inset 0 0 10px rgba(90, 128, 191, 0.8), 0 0px 0 #000;
  color: #efe;
  outline: 20px;
}

.theme-bg-card-2 {
  background: rgba(12, 22, 27, 0.4);
  border-color: #5a80bf;
  color: #efe;
  outline-width: 2px;
  padding: 30px;
  border-radius: 10px;
  margin: 10px;
  margin-top: -30px;
  color: #fff;
  text-align: center;
  font-size: 1.3rem;
  font-weight: normal;
  font-family: Arimo, sans-serif;
}
@keyframes glow2 {
  0% {
    border-color: #00adb4;
    box-shadow: 0 0 5px rgba(0, 255, 0, 0.2), inset 0 0 5px rgba(120, 166, 156, 0.1), 0 2px 0 #000;
  }

  100% {
    border-color: #78cce2;
    box-shadow: 0 0 8px rgba(90, 128, 191, 0.8), inset 0 0 10px rgba(120, 166, 156, 0.4), 0 2px 0 #000;
  }
}
@media only screen and (min-width: 600px) {
.theme-bg-card-2 {
  background: rgba(12, 22, 27, 0.4);
  border-color: #5a80bf;
  color: #efe;
  outline-width: 2px;
  padding: 5px;
  border-radius: 10px;
  top: 10px;
  color: #fff;
  text-align: center;
  font-size: 1.3rem;
  font-weight: normal;
  font-family: Arimo, sans-serif;
}
@keyframes glow2 {
  0% {
    border-color: #00adb4;
    box-shadow: 0 0 5px rgba(0, 255, 0, 0.2), inset 0 0 5px rgba(120, 166, 156, 0.1), 0 2px 0 #000;
  }

  100% {
    border-color: #78cce2;
    box-shadow: 0 0 8px rgba(90, 128, 191, 0.8), inset 0 0 10px rgba(120, 166, 156, 0.4), 0 2px 0 #000;
  }
}
}
.bg-content-4 {
    background: #131f25e7;
    padding: 0px;
    min-height: 87vh;
    -webkit-animation: gradient 25s ease infinite;
    -animation: gradient 25s ease infinite;
  }
    @-webkit-keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }
  
    @keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
      height: 100%;
    }
    
@media only screen and (max-width: 600px) {
  .bg-content-4 {
    background: #131f25e7;
    padding: 0px;
    min-height: 160vh;
    -webkit-animation: gradient 25s ease infinite;
    -animation: gradient 25s ease infinite;
  }
    @-webkit-keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }
  
    @keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
      height: 100%;
    } 
  }
/* 
@media only screen and (max-width: 900px) {
  .bg-content {
    background: #131f25e7;
    padding: 0px;
    min-height: 210vh;
    -webkit-animation: gradient 25s ease infinite;
    -animation: gradient 25s ease infinite;
  }
    @-webkit-keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }
  
    @keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
      height: 100%;
    } 
  } */
.theme-bg-card-2:hover {
  background: rgba(12, 22, 27, 0.7);
  outline-color: rgba(90, 128, 191, 0.7);
  outline-style: solid;
  animation: glow2 1800ms ease-out infinite alternate;
}

.theme-bg-card-warning {
  background: rgba(255, 255, 0, 0.3);
  outline-color: #5a80bf;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
}

.theme-bg-card-warning:hover {
  background: rgba(255, 255, 0, 0.5);
  outline-color: #5a80bf;
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #393;
  box-shadow: 0 0 5px rgba(0, 255, 0, 0.2), inset 0 0 5px rgba(0, 255, 0, 0.1), 0 2px 0 #000;
  color: #efe;
  outline: none;
}

.theme-bg-card-negative {
  background: rgba(255, 0, 0, 0.3);
  outline-color: #5a80bf;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
}

.theme-bg-card-negative:hover {
  background: rgba(255, 0, 0, 0.5);
  outline-color: #5a80bf;
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #ff0000;
  box-shadow: 0 0 5px rgba(255, 0, 0, 0.2), inset 0 0 5px rgba(255, 0, 0, 0.1), 0 2px 0 #000;
  color: #efe;
  outline: none;
}

.theme-bg-card-lg {
  background: rgba(16, 22, 58, 0.3);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
}

.theme-bg-card-lg:hover {
  background: rgba(16, 22, 58, 0.5);
  outline-color: #42da91;
  outline-style: solid;
  animation: glow 1000ms ease-out infinite alternate;
  border-color: #393;
  box-shadow: 0 0 7px rgba(0, 255, 0, 0.2), inset 0 0 7px rgba(0, 255, 0, 0.1), 0 2px 0 #000;
  outline: none;
}

@keyframes glow {
  0% {
    border-color: #00adb4;
    box-shadow: 0 0 5px rgba(0, 255, 0, 0.2), inset 0 0 5px rgba(120, 166, 156, 0.1), 0 2px 0 #000;
  }

  100% {
    border-color: #78cce2;
    box-shadow: 0 0 8px rgba(0, 255, 0, 0.8), inset 0 0 10px rgba(120, 166, 156, 0.4), 0 2px 0 #000;
  }
}
.card-animate-2 {
  animation-name: slideExpandUp;
  /* position: relative;
  position-fromtop: 100px; */
  animation-duration: 3s;
}

.slideExpandUp {
  animation-name: slideExpandUp;
  -webkit-animation-name: slideExpandUp;

  animation-duration: 2.7s;
  -webkit-animation-duration: 2.7s;

  animation-timing-function: ease-out;
  -webkit-animation-timing-function: ease -out;

  visibility: visible !important;
}

@keyframes slideExpandUp {
  0% {
    -webkit-transform: translateY(10%) scaleX(0.94);
  }
  30% {
    -webkit-transform: translateY(-5%) scaleX(0.95);
  }
  40% {
    -webkit-transform: translateY(3%) scaleX(0.96);
  }
  50% {
    -webkit-transform: translateY(0%) scaleX(1);
  }
}

@-webkit-keyframes slideExpandUp {
  0% {
    -webkit-transform: translateY(10%) scaleX(0.94);
  }
  30% {
    -webkit-transform: translateY(-5%) scaleX(0.95);
  }
  40% {
    -webkit-transform: translateY(3%) scaleX(0.96);
  }
  50% {
    -webkit-transform: translateY(0%) scaleX(1);
  }
}

.space1 {
  height: 35px;
}

.space2 {
  height: 1px;
}

.space3 {
  height: 15px;
}

.space4 {
  height: 1px;
}

.space5 {
  height: 100px;
}
.space6 {
  height: 10px;
}
.space7 {
  height: 10px;
}

.tabbar {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  align-items: center;
  & > li {
    margin: 0 11px;
    & > svg {
      width: 14px;
      height: 14px;
      display: block;
      fill: #2f3545;
      transition: opacity 0.3s ease;
    }
  }
  &.open {
    & > li {
      & > svg {
        opacity: 0.5;
      }
    }
  }
}

.Center & dribbble body {
  min-height: 100vh;
  font-family: Roboto, Arial;
  color: #adafb6;
  background: #171c28;
  display: flex;
  justify-content: center;
  align-items: center;
  .dribbble {
    position: fixed;
    display: block;
    right: 20px;
    bottom: 20px;
    img {
      display: block;
      height: 28px;
    }
  }
}

.v-card__title {
  font-size: 1rem !important;
}

.text-color-2 {
  color: #42da91 !important;
}

.user-ui {
  background: rgba(48, 64, 87, 1);
  opacity: 1;
  color: #fff;
  padding: 20px;
}

.theme-bg-2 {
  background: rgba(48, 64, 87, 0.3);
  color: #fff;
}
.menu-icon {
  background: rgba(48, 64, 87, 0.3);
  padding: 30px;
  display: inline-block;
  margin-left: 50px;
  /* margin-top: 20px; */
  text-align: center;
  cursor: pointer;
}
.menu-icon:hover {
  background: rgba(48, 64, 87, 0.5);
  padding: 30px;
  display: inline-block;
  margin-left: 50px;
  /* margin-top: 20px; */
  text-align: center;
  cursor: pointer;
}
.close-btn {
  position: absolute;
  right: 0px;
  margin-top: -60px;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
.icons {
  font-size: 40px;
  color: #fff;
  margin-top: 0px;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  bottom: 10px;
  text-align: center;
  color: #42da91 !important;
}
.icons:hover {
  font-size: 40px;
  color: #fff;
  margin-top: 0px;
  position: absolute;
  padding: 0px;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  color: #ffffff !important;
}
.detail-card {
  width: 800px;
  height: 400px;
  background: #304057;
  opacity: 0.75;
  position: absolute;
}
.chart {
  color: #fff;
  background: #304057;
  background-size: 400% 400%;
  margin-left: 0px;
  padding: 25px;
  width: 404px;
  cursor: pointer;
  top: -60px;
  min-height: 10vh;
  -webkit-animation: gradient 25s ease infinite;
  -animation: gradient 25s ease infinite;
}

@-webkit-keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@-webkit-keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
  height: 150%;
}
.section {
  width: 98%;
  top: 25px;
}

@media only screen and (min-width: 600px) {
  .section {
    width: 100%;
    top: 17%;
  }
}

.mobile-view {
  display: none;
}
.desktop-view {
  display: block;
}
.three-dot {
  margin-top: 10px;
  float: right;
  color: #fff;
}
.product-animate {
  animation-name: slideleft;
  position: relative;
  position-fromtop: 100px;
  animation-duration: 1s;
  transition: opacity 1s Elastic.easeIn;
}
.product-animate-out {
  animation-name: slideright;
  position: relative;
  position-fromtop: 100px;
  animation-duration: 1s;
  transition: opacity 1s Elastic.easeOut;
}
.info-animate {
  animation-name: slideleft;
  position: relative;
  position-fromtop: 100px;
  animation-duration: 1s;
  transition: opacity 1s Elastic.easeIn;
}
.info-animate-out {
  animation-name: slideright;
  position: relative;
  position-fromtop: 100px;
  animation-duration: 1s;
  transition: opacity 1s Elastic.easeOut;
}
.product {
  width: 400px;
}
/* Standard syntax */
@keyframes slideleft {
  0% {
    left: -800px;
    top: 0px;
  }
  100% {
    left: 10px;
    top: 0px;
  }
}
/* Standard syntax */
@keyframes slideright {
  0% {
    left: 800px;
    top: 0px;
  }
  100% {
    left: 0px;
    top: 0px;
  }
}
@keyframes slidetop {
  0% {
    bottom: -1000px;
    top: 0px;
  }
  100% {
    bottom: 10px;
    top: 0px;
  }
}
@keyframes slidebottom {
  0% {
    bottom: 1000px;
    top: 0px;
  }
  100% {
    bottom: 10px;
    top: 0px;
  }
}

.slideExpandUp {
  animation-name: slideExpandUp;
  -webkit-animation-name: slideExpandUp;

  animation-duration: 2.6s;
  -webkit-animation-duration: 2.6s;

  animation-timing-function: ease-out;
  -webkit-animation-timing-function: ease -out;

  visibility: visible !important;
}

@keyframes slideExpandUp {
  0% {
    transform: translateY(100%) scaleX(0.94);
  }
  30% {
    transform: translateY(-4%) scaleX(0.95);
  }
  40% {
    transform: translateY(2%) scaleX(0.96);
  }
  50% {
    transform: translateY(0%) scaleX(1);
  }
}

@-webkit-keyframes slideExpandUp {
  0% {
    -webkit-transform: translateY(100%) scaleX(0.94);
  }
  30% {
    -webkit-transform: translateY(-4%) scaleX(0.95);
  }
  40% {
    -webkit-transform: translateY(2%) scaleX(0.96);
  }
  50% {
    -webkit-transform: translateY(0%) scaleX(1);
  }
}

@media only screen and (max-width: 600px) {
  .product {
    width: 90%;
  }
  .card-margin {
    margin-top: 40px;
  }
  .mobile-view {
    display: block;
  }
  .desktop-view {
    display: none;
  }
  .menu-icon-2 {
    margin-left: 20px;
    color: #42da91 !important;
    margin-top: 20px;
  }
  .mb-margin {
    text-align: center;
  }
  .detail-card {
    width: 350px;
    height: 100%;
  }
  .callouts {
    padding: 100px;
    border: outline;
    background: #304057;
    opacity: 0.9;
    color: #11ece5;
    cursor: pointer;
    position: relative;
    margin-left: 540px;
    margin-right: auto;
    left: 100px;
    right: 0px;
    align: center;
    text-align: center;
    outline-color: #5a80bf;
    outline-style: solid;
    animation: glow 1800ms ease-out infinite alternate;
    border-color: #5a80bf;
    box-shadow: 0 0 5px rgba(90, 128, 191, 0.2), inset 0 0 3px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
    outline: none;
  }
  @keyframes glow {
    0% {
      border-color: #11ece5;
      box-shadow: 0 0 5px rgba(90, 128, 191, 0.2), inset 0 0 6px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
    }

    100% {
      border-color: #11ece5;
      box-shadow: 0 0 8px rgba(90, 128, 191, 0.8), inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
    }
  }
   
  .container-fonts {
    font-size: 1rem;
  }
  .user-speach {
    position: absolute;
    top: -350px;
    font-size: 16px;
    width: 80%;
    left: 200px;
    right: 0px;
    border-radius: 15px;
    color: #fff;
    background: linear-gradient(-45deg, #0f1724, #151f2f, #19253a, #304057, #0f1724);
    background-size: 400% 400%;

    -webkit-animation: gradient 15s ease infinite;
    -animation: gradient 15s ease infinite;
  }

  @-webkit-keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
    height: 150%;
  }

  .button {
    text-decoration: none;
    font-family: Arial, Helvetica, sans-serif;
  }

  .about {
    padding: 30px;
    background: rgba(48, 64, 87, 0.1);
    color: #111;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .callouts:hover {
    padding: 30px;
    border: outline;
    background: #304057;
    opacity: 1;
    color: #11ece5;
    cursor: pointer;
    position: relative;
    margin-left: 540px;
    margin-right: auto;
    left: 100px;
    right: 0px;
    align: center;
    text-align: center;
  }
}
</style>
